module.exports = __webpack_public_path__ + "img/logo_kompas.2f13526c.png";